import { render, staticRenderFns } from "./Signatory.vue?vue&type=template&id=9a29af76&scoped=true"
import script from "./Signatory.vue?vue&type=script&lang=js"
export * from "./Signatory.vue?vue&type=script&lang=js"
import style0 from "./Signatory.vue?vue&type=style&index=0&id=9a29af76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a29af76",
  null
  
)

export default component.exports